// extracted by mini-css-extract-plugin
export default {"inputContainer":"style_inputContainer__S-E7t"};